import { render, staticRenderFns } from "./Stratage.vue?vue&type=template&id=404ee5f7&scoped=true&"
import script from "./Stratage.vue?vue&type=script&lang=js&"
export * from "./Stratage.vue?vue&type=script&lang=js&"
import style1 from "./Stratage.vue?vue&type=style&index=1&id=404ee5f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404ee5f7",
  null
  
)

export default component.exports